import { Component, OnInit } from '@angular/core';
import { PretragaKatalogaComponent } from './pretraga-kataloga.component';

@Component({
  selector: 'app-moje-gradivo',
  templateUrl: './pretraga-kataloga.component.html',
  styleUrls: ['./pretraga-kataloga.component.css']
})
export class MojeGradivoComponent
  extends PretragaKatalogaComponent
  implements OnInit
{
  override ngOnInit() {
    this.changeView('moje_gradivo');
  }
}
